export const STATIC_ROUTES_CONFIG = [
    { name: 'Price', path: '/price/:logout' },
    { name: 'Price', path: '/price' },
    { name: 'Auth', path: '/register', props: { type: 'register' } },
    { name: 'Auth', path: '/auth/:id' },
    { name: 'Auth', path: '/auth' },
    { name: 'EmailSuccess', path: '/email_success' },
    { name: 'EmailConfirm', path: '/email_confirm' },
    { name: 'EmailResend', path: '/email_resend' },
    { name: 'DeleteAccount', path: '/account_delete' },
    { name: 'ReleaseNotes', path: '/release_notes' },
    { name: 'Strategy', path: '/strategy/:id' },
    { name: 'Documentation', path: '/documentation/:id' },
    { name: 'Checkout', path: '/checkout/:id' },
    { name: 'Checkout', path: '/checkout' },
    { name: 'Cart', path: '/cart' },
    { name: 'Finish', path: '/finish/:id' },
    { name: 'Forgot', path: '/forgot' },
    { name: 'Forgot_success', path: '/forgot_success' },
    { name: 'ForgotCreatePassword', path: '/create_password/:token' },
    { name: 'Empty', path: '/empty' },
    { name: 'CheckTwoFactor', path: '/check_two_factor' },
    { name: 'PasswordChanged', path: '/password_changed' },
    { name: 'Marketplace', path: '/strategies-library' },
    { name: 'MarketplaceRedirect', path: '/marketplace' }
];